import { GAME_TYPE, QUESTION_TYPE } from "../constants";

const baseRoute = (name = "") => {
  return `${process.env.REACT_APP_DOMAIN_DIR}/${name}`;
};

const apiBaseUrl = () => {
  return process.env.REACT_APP_API_DOMAIN + "api/user/";
};

const localStorageToken = () => {
  return process.env.REACT_APP_WEB_STORAGE_TOKEN;
};

const getStatusClass = (status) => {
  switch (status) {
    case 10:
      return "SCHEDULED";
    case 15:
      return "ONGOING";
    case 20:
      return "CANCELLED";
    case 25:
      return "ON_HOLD";
    case 30:
      return "COMPLETED";
    default:
      return "";
  }
};

const getCriteriaType = (status) => {
  switch (status) {
    case 10:
      return "ORDER";
    case 20:
      return "REVIEW";
    default:
      return "";
  }
};

const getIncentiveTier = (status) => {
  switch (status) {
    case "1_month":
      return "1 Month";
    case "2_month":
      return "2 Month";
    case "3_month":
      return "3 Month";
    default:
      return "";
  }
};

const getOrderStatus = (status) => {
  switch (status) {
    case 10:
      return "ORDERED";
    case 20:
      return "PAID";
    case 30:
      return "READY FOR DELIVERY";
    case 40:
      return "DELIVERED";
    case 41:
      return "REVIEWED";
    case 50:
      return "CANCELLED";
    default:
      return "";
  }
};

const statusValues = [10, 20, 30, 40, 41, 50];

const getOrderType = (type) => {
  switch (type) {
    case 10:
      return "PICKUP";
    case 20:
      return "DELIVERY";
    default:
      return "";
  }
};
const typeValues = [10, 20];

const shopStatus = [10, 20, 30];

const getShopStatus = (status) => {
  switch (status) {
    case 10:
      return "Approval Pending";
    case 20:
      return "Approved";
    case 30:
      return "Rejected";
    default:
      return "";
  }
};

const CATEGORY_TYPE = { FOOD: 10, FASHION: 20, OTHER: 30 };

const getCategoryType = (type) => {
  switch (type) {
    case CATEGORY_TYPE.FOOD:
      return "Food";
    case CATEGORY_TYPE.FASHION:
      return "Fashion";
    case CATEGORY_TYPE.OTHER:
      return "Other";
    default:
      return "";
  }
};

export const incentiveTierList = [
  { label: "1 Month", value: "1_month" },
  { label: "2 Months", value: "2_month" },
  { label: "3 Months", value: "3_month" },
];

export {
  baseRoute,
  apiBaseUrl,
  localStorageToken,
  getStatusClass,
  getCriteriaType,
  getOrderStatus,
  getOrderType,
  getShopStatus,
  getCategoryType,
  CATEGORY_TYPE,
  statusValues,
  typeValues,
  shopStatus,
  getIncentiveTier,
};
